import React from "react";

const AppButton = ({
	bgColor,
	txColor,
	title,
	onClick,
	className,
	props,
	width = "",
}) => {
	return (
		<button
			className={`w-${width} px-3 py-[10px] ${
				!bgColor ? "bg-[#15337a]" : bgColor
			} ${
				!txColor ? "text-[#d8dde6]" : ""
			} text-[${txColor}] rounded-md font-semibold hover:bg-orange-950 active:bg-slate-950 border-0 outline-none ${className}`}
			onClick={onClick}
			{...props}
		>
			{title}
		</button>
	);
};

export default AppButton;
